import React from 'react'

export const Loading: React.FC = () => (
  <div className="vh-100 d-flex align-items-center justify-content-center text-primary">
    <h4 className="mb-0 mr-3">Loading...</h4>
    <div className="spinner-border" />
  </div>
)